import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getNamedAnalysis = api(async function getNamedAnalysis(
    name,
    reportDuration,
    granularity = "hour",
    options = {}
) {
    return query(
        gql`
            query getNamedAnalysis($name: String, $options: JSON, $reportDuration: Int, $granularity: String) {
                getNamedAnalysis(
                    name: $name
                    options: $options
                    reportDuration: $reportDuration
                    granularity: $granularity
                )
            }
        `,
        { name, options, reportDuration, granularity },
        { returns: "getNamedAnalysis" }
    )
})
